import { render, staticRenderFns } from "./RiskOrgnManage.vue?vue&type=template&id=5b25578c&"
import script from "./RiskOrgnManage.vue?vue&type=script&lang=js&"
export * from "./RiskOrgnManage.vue?vue&type=script&lang=js&"
import style0 from "./RiskOrgnManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports